import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_BOOKING_FAILED,
  GET_BOOKING_REQUESTED,
  GET_BOOKING_SUCCESS,
  GET_CUSTOMER_MATRIX_FAILED,
  GET_CUSTOMER_MATRIX_REQUESTED,
  GET_CUSTOMER_MATRIX_SUCCESS,
  GET_REVENUE_EXPORT_FAILED,
  GET_REVENUE_EXPORT_REQUESTED,
  GET_REVENUE_EXPORT_SUCCESS,
  GET_REVENUE_FAILED,
  GET_REVENUE_MATRIX_FAILED,
  GET_REVENUE_MATRIX_REQUESTED,
  GET_REVENUE_MATRIX_SUCCESS,
  GET_REVENUE_REQUESTED,
  GET_REVENUE_SUCCESS,
} from "resources/actionTypes";
import {
  bookingApi,
  customerMatrixApi,
  revenueApi,
  revenueExportApi,
  revenueMatrixApi,
} from "services/ReportService";

function* fetchBooking(action) {
  try {
    const payload = action.payload || {};
    const userBooking = yield call(bookingApi, payload);
    yield put({ type: GET_BOOKING_SUCCESS, userBooking: userBooking });
  } catch (e) {
    yield put({ type: GET_BOOKING_FAILED, message: e.message })
    toast.error(e.message || 'Get Booking Failed')
  }
}

export function* bookingSaga() {
  yield takeEvery(GET_BOOKING_REQUESTED, fetchBooking);
}

function* fetchRevenue(action) {
  try {
    const payload = action.payload || {};
    const userRevenue = yield call(revenueApi, payload);
    yield put({ type: GET_REVENUE_SUCCESS, userRevenue: userRevenue });
  } catch (e) {
    yield put({ type: GET_REVENUE_FAILED, message: e.message });
  }
}

export function* revenueSaga() {
  yield takeEvery(GET_REVENUE_REQUESTED, fetchRevenue);
}

function* fetchRevenueMatrix(action) {
  try {
    const payload = action.payload || {};
    const userRevenueMatrix = yield call(revenueMatrixApi, payload);
    yield put({
      type: GET_REVENUE_MATRIX_SUCCESS,
      userRevenueMatrix: userRevenueMatrix,
    });
  } catch (e) {
    yield put({ type: GET_REVENUE_MATRIX_FAILED, message: e.message });
  }
}

export function* revenueMatrixSaga() {
  yield takeEvery(GET_REVENUE_MATRIX_REQUESTED, fetchRevenueMatrix);
}

function* fetchRevenueExport(action) {
  try {
    const payload = action.payload || {};
    const userRevenueExport = yield call(revenueExportApi, payload);
    yield put({
      type: GET_REVENUE_EXPORT_SUCCESS,
      userRevenueExport: userRevenueExport,
    });
    if(userRevenueExport?.success){
      toast.success(userRevenueExport?.message)
    }
  } catch (e) {
    yield put({ type: GET_REVENUE_EXPORT_FAILED, message: e.message });
  }
}

export function* revenueExportSaga() {
  yield takeEvery(GET_REVENUE_EXPORT_REQUESTED, fetchRevenueExport);
}

function* fetchCustomerMatrix(action) {
  try {
    const payload = action.payload || {};
    const userCustomerMatrix = yield call(customerMatrixApi, payload);
    yield put({
      type: GET_CUSTOMER_MATRIX_SUCCESS,
      userCustomerMatrix: userCustomerMatrix,
    });
  } catch (e) {
    yield put({ type: GET_CUSTOMER_MATRIX_FAILED, message: e.message });
  }
}

export function* customerMatrixSaga() {
  yield takeEvery(GET_CUSTOMER_MATRIX_REQUESTED, fetchCustomerMatrix);
}
